import React from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Privacy Policy | AAMSchool</title>
        <link rel="canonical" href="https://www.aamschool.in/privacy-policy" />
        <meta
          name="description"
          content="Read the AAMSchool Privacy Policy to understand how basic user information, cookies, analytics, and communication data may be handled."
        />
        <meta property="og:title" content="Privacy Policy | AAMSchool" />
        <meta
          property="og:description"
          content="Read the AAMSchool Privacy Policy to understand how basic user information, cookies, analytics, and communication data may be handled."
        />
        <meta property="og:url" content="https://www.aamschool.in/privacy-policy" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Privacy Policy</h1>
      <p className="page-lead">
        This Privacy Policy explains how AAMSchool Naukari may collect, use, and protect basic user
        information when visitors access the website.
      </p>

      <section className="page-policy-section">
        <h2>Basic Information</h2>
        <p>
          At AAMSchool Naukari, the privacy of our visitors is important to us. We do not knowingly
          collect personal information unless it is voluntarily shared through email or other direct
          communication methods.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Log Files and Cookies</h2>
        <p>
          Like many websites, we may use log files. Information may include IP address, browser
          type, ISP, date and time stamp, and pages visited. This information is typically used for
          analytics, site maintenance, and improving user experience.
        </p>
        <p>
          We may also use cookies to remember visitor preferences, improve performance, and present
          content in a more useful format based on device or browsing behavior.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Third-Party Services and Ads</h2>
        <p>
          Some pages may use third-party tools or embedded services for analytics, performance,
          security, or content delivery. These services may collect limited technical information in
          line with their own policies.
        </p>
        <p>
          We may also use Google AdSense or similar advertising services. Such services may use
          cookies or related technologies to serve more relevant ads based on user visits to this
          and other websites.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Communication and User Choice</h2>
        <p>
          If you contact us by email or through any listed communication channel, we may keep your
          message long enough to respond, resolve the issue, or maintain a basic record of the
          conversation.
        </p>
        <p>
          Users who do not wish to share personal information should avoid sending sensitive details
          by email and should review browser settings related to cookies and site data where
          available.
        </p>
        <p>By using our website, you consent to this Privacy Policy and agree to its terms.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
